import React, { useEffect } from 'react';
import { Table, Container as ContainerSuite } from 'rsuite';
import { moeda } from '../../../components/funcoes';
import { Container, ContainerInfo } from '../styles';

const ImprimirRelatorioCuponsUtilizados = () => {
  const [data, setData] = React.useState({
    registros: [],
    total: 0,
    descontoTotal: 0,
    totalLiquido: 0,
  });
  const { Column, HeaderCell, Cell } = Table;
  
  useEffect(() => {
    const dataJson = JSON.parse(localStorage.getItem('relatorioCuponsUtilizados'));
    if(dataJson){
      setData(dataJson);
    }
  },[]);
  
  return (
    <ContainerSuite style={{ padding: '10px' }}>
      <Container
        style={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ContainerInfo>
          <h3>Relatório de Cupons Utilizados</h3>
        </ContainerInfo>
      </Container>
      <Container>
        <ContainerInfo/>
        <div>
          <ContainerInfo>
            <text>Total Bruto: {moeda(data.total)}</text>
          </ContainerInfo>
          <ContainerInfo>
            <text>Desc. Total: {moeda(data.descontoTotal)}</text>
          </ContainerInfo>
          <ContainerInfo>
            <text>Total líquido: {moeda(data.totalLiquido)}</text>
          </ContainerInfo>
        </div>
      </Container>
      <Table height={600} data={data.registros} bordered={true}>
        <Column flexGrow={1} fixed>
          <HeaderCell>Cupom</HeaderCell>
          <Cell dataKey="Cupom" />
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Qtd. Utilizados</HeaderCell>
          <Cell>{(rowData) => <text>{+(rowData.Quantidade)}</text>}</Cell>
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Desconto Total</HeaderCell>
          <Cell>{(rowData) => <text>{moeda(rowData.DescontoTotal)}</text>}</Cell>
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Total com Desconto</HeaderCell>
          <Cell>{(rowData) => <text>{moeda(rowData.ValorComDesconto)}</text>}</Cell>
        </Column>

        <Column>
          <HeaderCell>Valor Total</HeaderCell>
          <Cell>{(rowData) => <text>{moeda(rowData.ValorTotal)}</text>}</Cell>
        </Column>
      </Table>
    </ContainerSuite>
  );
}

export default ImprimirRelatorioCuponsUtilizados;